module.exports = {
  domain: {
    desktop: "pabets.perf.use2.racing.fndlext.net",
    mobile: "pabets.perf.use2.racing.fndlext.net",
    talentPicks: "pabets.perf.use2.racing.fndlext.net/talent-picks/",
    equibase: "equibase-store.perf.use2.racing.fndlext.net"
  },
  recaptchaID: "6Lf-4hUqAAAAAGupa6W70kpZVsaFd7yaxz5pHD8r",
  recaptchaIdNative: "6Le9B1YqAAAAAJEWJZsQittPtHDcjz6xLNORgHyI"
};
